// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.leavemanageHeading{
    font-family: "Inter";
font-size: 18px;
font-weight: 600;
line-height: 21.78px;
letter-spacing: 0.02em;
text-align: left;
color:#0070E9;
align-items: center;

}
.leavepage-1stgrid{
    /* align-items: center; */
    display: flex;
    justify-content: end;
    /* justify-content: center; */
}
.dateInputforleave{
    background-color: #008A27 !important;    
}
.dateInputforleave button{
    color: #fff !important;
}
.dateInputforleave input{
    padding: 9px !important;
    width: 100%;
    color: #fff !important;
}


.leavehistory{
    width: 100% !important;
height:39px !important;

gap: 10px !important;

font-family: "Inter" !important;
font-size: 16px !important;
font-weight: 700 !important;
line-height: 19.36px !important;
letter-spacing: 0.02em !important;
text-align: left !important;
/* padding: 10px, 20px, 10px, 20px !important; */
color:#FE602F !important;
text-transform: capitalize !important;
border: 1px solid #FE602F !important


}

.MuiChartsLegend-mark{
    border-radius: 50% !important;
}


.Leave{
    font-family: "Inter" !important;
font-size: 16px !important;
font-weight: 600 !important;
line-height: 19.36px !important;
letter-spacing: 0.02em !important;
text-align: left !important;

color:#0070E9 !important


}

.nonleaveTab{
    font-family: "Inter" !important;
    font-size: 16px !important;
    font-weight: 600 !important;
    line-height: 19.36px !important;
    letter-spacing: 0.02em !important;
    text-align: left !important;
    color:#002C5D !important;
    

}

.css-1dk1qys-MuiTabs-indicator{
    color:#0070E9 !important
}


.rlreqlevreqButton{
 
    width:100% !important;
    /* max-width: 155px !important; */
height:39px !important;
padding: 10px 20px 10px 20px !important;
gap: 10px !important;
border-radius: 3px 0px 0px 0px !important;
/* opacity: 0px !important; */
background-color: #FE602F !important;
color: white !important;
text-transform: none !important;
font-size: 15px !important;
font-weight: 600 !important;
/* font-family: "Inter" !important;
font-size: 16px !important;
font-weight: 700 !important;
line-height: 19.36px !important;
letter-spacing: 0.02em !important;
text-align: left !important;
color: white !important */



}


.rdp{
    width:100% !important
}
.rdp-caption{
    width:100% !important
}
.rdp-month .rdp-caption_start .rdp-caption_end{
    width:100% !important
}

`, "",{"version":3,"sources":["webpack://./src/views/panel/LeaveManagement/LeaveDashboard.css"],"names":[],"mappings":"AAAA;IACI,oBAAoB;AACxB,eAAe;AACf,gBAAgB;AAChB,oBAAoB;AACpB,sBAAsB;AACtB,gBAAgB;AAChB,aAAa;AACb,mBAAmB;;AAEnB;AACA;IACI,yBAAyB;IACzB,aAAa;IACb,oBAAoB;IACpB,6BAA6B;AACjC;AACA;IACI,oCAAoC;AACxC;AACA;IACI,sBAAsB;AAC1B;AACA;IACI,uBAAuB;IACvB,WAAW;IACX,sBAAsB;AAC1B;;;AAGA;IACI,sBAAsB;AAC1B,sBAAsB;;AAEtB,oBAAoB;;AAEpB,+BAA+B;AAC/B,0BAA0B;AAC1B,2BAA2B;AAC3B,+BAA+B;AAC/B,iCAAiC;AACjC,2BAA2B;AAC3B,gDAAgD;AAChD,wBAAwB;AACxB,qCAAqC;AACrC;;;AAGA;;AAEA;IACI,6BAA6B;AACjC;;;AAGA;IACI,+BAA+B;AACnC,0BAA0B;AAC1B,2BAA2B;AAC3B,+BAA+B;AAC/B,iCAAiC;AACjC,2BAA2B;;AAE3B;;;AAGA;;AAEA;IACI,+BAA+B;IAC/B,0BAA0B;IAC1B,2BAA2B;IAC3B,+BAA+B;IAC/B,iCAAiC;IACjC,2BAA2B;IAC3B,wBAAwB;;;AAG5B;;AAEA;IACI;AACJ;;;AAGA;;IAEI,qBAAqB;IACrB,iCAAiC;AACrC,sBAAsB;AACtB,uCAAuC;AACvC,oBAAoB;AACpB,yCAAyC;AACzC,6BAA6B;AAC7B,oCAAoC;AACpC,uBAAuB;AACvB,+BAA+B;AAC/B,0BAA0B;AAC1B,2BAA2B;AAC3B;;;;;;yBAMyB;;;;AAIzB;;;AAGA;IACI;AACJ;AACA;IACI;AACJ;AACA;IACI;AACJ","sourcesContent":[".leavemanageHeading{\r\n    font-family: \"Inter\";\r\nfont-size: 18px;\r\nfont-weight: 600;\r\nline-height: 21.78px;\r\nletter-spacing: 0.02em;\r\ntext-align: left;\r\ncolor:#0070E9;\r\nalign-items: center;\r\n\r\n}\r\n.leavepage-1stgrid{\r\n    /* align-items: center; */\r\n    display: flex;\r\n    justify-content: end;\r\n    /* justify-content: center; */\r\n}\r\n.dateInputforleave{\r\n    background-color: #008A27 !important;    \r\n}\r\n.dateInputforleave button{\r\n    color: #fff !important;\r\n}\r\n.dateInputforleave input{\r\n    padding: 9px !important;\r\n    width: 100%;\r\n    color: #fff !important;\r\n}\r\n\r\n\r\n.leavehistory{\r\n    width: 100% !important;\r\nheight:39px !important;\r\n\r\ngap: 10px !important;\r\n\r\nfont-family: \"Inter\" !important;\r\nfont-size: 16px !important;\r\nfont-weight: 700 !important;\r\nline-height: 19.36px !important;\r\nletter-spacing: 0.02em !important;\r\ntext-align: left !important;\r\n/* padding: 10px, 20px, 10px, 20px !important; */\r\ncolor:#FE602F !important;\r\ntext-transform: capitalize !important;\r\nborder: 1px solid #FE602F !important\r\n\r\n\r\n}\r\n\r\n.MuiChartsLegend-mark{\r\n    border-radius: 50% !important;\r\n}\r\n\r\n\r\n.Leave{\r\n    font-family: \"Inter\" !important;\r\nfont-size: 16px !important;\r\nfont-weight: 600 !important;\r\nline-height: 19.36px !important;\r\nletter-spacing: 0.02em !important;\r\ntext-align: left !important;\r\n\r\ncolor:#0070E9 !important\r\n\r\n\r\n}\r\n\r\n.nonleaveTab{\r\n    font-family: \"Inter\" !important;\r\n    font-size: 16px !important;\r\n    font-weight: 600 !important;\r\n    line-height: 19.36px !important;\r\n    letter-spacing: 0.02em !important;\r\n    text-align: left !important;\r\n    color:#002C5D !important;\r\n    \r\n\r\n}\r\n\r\n.css-1dk1qys-MuiTabs-indicator{\r\n    color:#0070E9 !important\r\n}\r\n\r\n\r\n.rlreqlevreqButton{\r\n \r\n    width:100% !important;\r\n    /* max-width: 155px !important; */\r\nheight:39px !important;\r\npadding: 10px 20px 10px 20px !important;\r\ngap: 10px !important;\r\nborder-radius: 3px 0px 0px 0px !important;\r\n/* opacity: 0px !important; */\r\nbackground-color: #FE602F !important;\r\ncolor: white !important;\r\ntext-transform: none !important;\r\nfont-size: 15px !important;\r\nfont-weight: 600 !important;\r\n/* font-family: \"Inter\" !important;\r\nfont-size: 16px !important;\r\nfont-weight: 700 !important;\r\nline-height: 19.36px !important;\r\nletter-spacing: 0.02em !important;\r\ntext-align: left !important;\r\ncolor: white !important */\r\n\r\n\r\n\r\n}\r\n\r\n\r\n.rdp{\r\n    width:100% !important\r\n}\r\n.rdp-caption{\r\n    width:100% !important\r\n}\r\n.rdp-month .rdp-caption_start .rdp-caption_end{\r\n    width:100% !important\r\n}\r\n\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
